import React from 'react'
import { useInstData } from 'tyan/public/hooks'

let RichTextEditor

export default props => {
	const { me, setState } = useInstData()

	const loadRichTextEditor = async () => {
		const m = await import(/* webpackChunkName: "chunks/public/fb/RTE" */ './RichTextEditor')
		m && m.default && (RichTextEditor = m.default)
		setState({})
	}

	!RichTextEditor && loadRichTextEditor()

	return RichTextEditor && <RichTextEditor {...props} /> || null
}
